<template>
  <svg fill="none" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="a"
      height="748"
      maskUnits="userSpaceOnUse"
      width="615"
      x="221"
      y="134"
    >
      <path
        clip-rule="evenodd"
        d="m480.075 441.618 26.278 121.901c5.205 24.147 25.584 42.066 50.217 44.155l127.897 10.849 12.274 45.392a28.08 28.08 0 0 1-4.214 23.587l-129.588 182.43c-7.077 9.966-19.792 14.216-31.449 10.512l-201.452-63.999a28.1 28.1 0 0 1-16.873-14.711l-89.091-187.253a28.076 28.076 0 0 1 6.713-33.057l165.418-146.92zm301.32-120.173c-3.803-11.993-15.124-19.996-27.708-19.592l-158.468 5.1-77.868 109.818 105.747 8.968c23.565 1.999 43.362 18.517 49.53 41.33l31.626 116.944 116.629-61.767c12-6.356 17.739-20.373 13.635-33.308zM324.221 153.663c4.266-12.658 16.861-20.565 30.125-18.914l165.72 20.637a28.11 28.11 0 0 1 23.787 21.014l28.719 113.893-87.715 123.704-88.433-7.656-109.882-78.488c-10.064-7.188-14.243-20.103-10.295-31.817z"
        fill="#fff"
        fill-rule="evenodd"
      />
      <path
        clip-rule="evenodd"
        d="m533.841 557.606-24.427-113.319 111.303 9.44c11.783 1 21.681 9.258 24.765 20.664l31.174 115.276-117.707-9.984c-12.317-1.045-22.506-10.004-25.108-22.077"
        fill="#fff"
        fill-rule="evenodd"
      />
    </mask>
    <g mask="url(#a)">
      <path d="M969.288 133v125H88V133z" fill="#F7022D" />
      <path d="M969.288 258v125H88V258z" fill="#F87316" />
      <path d="M969.288 383v125H88V383z" fill="#FCE22B" />
      <path d="M969.288 508v125H88V508z" fill="#2FAD4C" />
      <path d="M969.288 633v125H88V633z" fill="#2C5EFB" />
      <path d="M969.288 758v125H88V758z" fill="#7416A8" />
    </g>
  </svg>
</template>
